/**
 * @flow
 * @relayHash dd6cbdacfc1a7fa835dbbfb8cd8faa02
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteSupplierContactMutationVariables = {|
  id: string
|};
export type DeleteSupplierContactMutationResponse = {|
  +deleteSupplierContact: {|
    +id: string
  |}
|};
export type DeleteSupplierContactMutation = {|
  variables: DeleteSupplierContactMutationVariables,
  response: DeleteSupplierContactMutationResponse,
|};
*/


/*
mutation DeleteSupplierContactMutation(
  $id: String!
) {
  deleteSupplierContact(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteSupplierContact",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "SupplierContactModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteSupplierContactMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteSupplierContactMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteSupplierContactMutation",
    "id": null,
    "text": "mutation DeleteSupplierContactMutation(\n  $id: String!\n) {\n  deleteSupplierContact(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f2717ed7f17c068d61efbf4f8ec420f3';
module.exports = node;
